import type { ChatMessage, ChatSession } from "@/types";

export function resolvePersistedActiveSessionId(
  sessions: ChatSession[],
  persistedActiveSessionId: string | null | undefined,
): string | null {
  if (!persistedActiveSessionId) {
    return null;
  }

  return sessions.some((session) => session.id === persistedActiveSessionId)
    ? persistedActiveSessionId
    : null;
}

export function getActiveAcpSessionId(
  sessions: ChatSession[],
  activeSessionId: string | null | undefined,
): string | null {
  if (!activeSessionId) {
    return null;
  }

  return sessions.find((session) => session.id === activeSessionId)?.acpSessionId ?? null;
}

export function prepareMessagesForPersistence(messages: ChatMessage[]): ChatMessage[] {
  return messages.map((message) => {
    if (message.role !== "agent" || message.id !== "streaming") {
      return message;
    }

    return {
      ...message,
      id: crypto.randomUUID(),
    };
  });
}
